import { FormProvider, useForm } from 'react-hook-form';
import { useRouter } from 'next/router';
import Text from '@components/common/text';
import FileVO from '@domain/vo/common/FileVO';
import { useCreatePassReviewPosts, usePassReviewPostQuestions } from '@repository/passReview/usePassReview';
import BasicInfo from './basicInfo';
import PassInfo from './passInfo';
import { PassReviewAnswerRq } from '@domain/rq/passReview/PassReviewPostSaveRq';
import { FontStyle } from '@domain/constant/fontStyle';
import { RouteUrl } from '@utils/routeUtil';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

export interface FormType {
  title: string;
  jobGroup: { label: string; value: string };
  jobTitle: { label: string; value: string };
  companyName: string;
  passDate: string;
  answers: string[];
  certificationImageUid: FileVO[];
}

const Edit = () => {
  const router = useRouter();
  const { data: questionData } = usePassReviewPostQuestions({ type: 'DEFAULT' });
  const { mutateAsync: createPassReview } = useCreatePassReviewPosts();
  const methods = useForm<FormType>();
  const { handleSubmit } = methods;

  const onSubmit = async (data: FormType) => {
    const answersDto = questionData?.questions.map((question, idx) => ({
      questionSn: question.questionSn,
      answer: data.answers[idx],
    }));

    await createPassReview(
      {
        ...data,
        jobGroupCode: Number(data.jobGroup.value),
        jobTitleCode: Number(data.jobTitle.value),
        certificationImageUid: data.certificationImageUid[0].fileUid,
        answers: answersDto as PassReviewAnswerRq[],
      },
      {
        onSuccess: (rs) => {
          router.push(`${RouteUrl.PASSBOARD}/${rs.passReviewPostSn}`);
        },
      },
    );
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Text fontStyle={FontStyle.H4_B}>합격 후기 작성하기</Text>

        <BasicInfo />

        <div className={cx('divider')} />

        <PassInfo data={questionData} />
      </form>
    </FormProvider>
  );
};
export default Edit;
